import { type FC } from "react";
import FontAwesomeLight from "../../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import Duration from "../../../Duration/Duration";
import { type MediaFolderType } from "../MediaUtilities";

interface Props {
    folder: MediaFolderType;
    small?: boolean;
}

export const FolderDetails: FC<Props> = ({ folder, small }) => {
    if(small) {
        return (
            <div className="item">
                <div className="media">
                    <FontAwesomeLight icon="folder" />
                </div>
                <div className="details">
                    <div className="name">{folder.name}</div>
                </div>
            </div>
        );
    }

    return (
        <div className="item">
            <div className="media">
                <FontAwesomeLight icon="folder" />
            </div>
            <div className="details">
                <div className="name">{folder.name}</div>
                {folder.createdAt && (
                    <div className="created-at">
                        Created
                        <Duration
                            key={folder.uuid}
                            timestamp={folder.createdAt}
                        />
                    </div>
                )}
                {folder.updatedAt && (
                    <div className="updated-at">
                        Modified
                        <Duration
                            key={folder.uuid}
                            timestamp={folder.updatedAt}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
